import { ArcaneCurseEffect } from 'game/extended/heros/mage/arcane_curse/arcane_curse_effect'

export default {
    events: {},
    effects: {
        ArcaneCurseEffect
    },
    requirements: {}
}